/** @prettier */
let landingAPISetting: null | boolean = null;

export const setShowHeaderLineMenu = (value: boolean) => {
  landingAPISetting = value;
};

export const showHeaderLineMenu = () =>
  landingAPISetting != null ? landingAPISetting : false;
